import { Box } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export interface IListable {
  first: boolean;
  last: boolean;
  shouldRenderDefaultBackground?: boolean;
}

export const Section = Box.withConfig<IListable>(p => ({
  backgroundColor: p.shouldRenderDefaultBackground
    ? getDesignToken('background-default')
    : 'transparent',
  paddingX: 0,
  paddingTop: {
    base: '4',
    md: p.first ? '7' : '4',
  },
  paddingBottom: p.last ? '7' : '4',
}));

interface ISpacer {
  $isSmall: boolean;
}
export const Spacer = Box.withConfig<ISpacer>(p => ({
  height: {
    base: '0',
    md: p.$isSmall ? '78px' : '110px',
  },
}));
